import EcoLink from 'eco-design/base/eco-link';
import EcoImg from 'eco-design/base/eco-img';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { useRouter } from 'next/router';
import gtm from 'eco-design-reliance/gtm';

const websiteUrl = process.env.NEXT_PUBLIC_WEB_HOST;
const homeUrl = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;

export default function ProductItem({ product, isMobile = false }: any) {
    const { Link, gloproductlist, useLang } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const getDataLayer = (name: string) => {
        return {
            event: 'uaEvent',
            event_name: 'select_search_result',
            list_name: 'Product',
            title_name: name,
            button_name: 'learn_more',
        };
    };

    const imageInfo = JSON.parse(product?.images);

    const imagePath =
        imageInfo?.transparentImages ||
        imageInfo?.images ||
        imageInfo?.navigatorImages ||
        'https://websiteoss.ecoflow.com/img/search/2461bcec7e9c85a041ff2f95d5e476ea.png';

    const handleLearnMoreClick = (product: any) => {
        if (typeof window !== 'undefined') {
            const searchEntry: any = localStorage.getItem('search_entry');

            gtm.push({
                event: 'uaEvent',
                event_name: 'select_product',
                list_name: 'none',
                product_name: product?.spuName,
                button_name: t('support.site_support_learn_more'),
                position: `search_${product?.spuName}`,
                navigation_name: 'none',
                source_method: searchEntry || '',
            });
        }
    };

    const handleBuyNowClick = (product: any) => {
        if (typeof window !== 'undefined') {
            const searchEntry: any = localStorage.getItem('search_entry');

            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: product?.spuName,
                position: 'search_explore_top',
                view_page_type: 'shopify PDP',
                navigation_name: 'none',
                source_method: searchEntry || '',
            });
        }
    };

    const handleProductLink = (product: any) => {
        if (product?.domainType === 'ENTERPRISE') {
            return `${homeUrl}/${locale}/${product?.learnLink}`;
        }
        return `${websiteUrl}/${locale}/${product?.learnLink}`;
    };
    return (
        <div className={css.productItem}>
            <div className="productImg">
                <EcoImg alt={product?.spuName} pc={imagePath} h5={imagePath} />
            </div>
            <div className="productInfo">
                <div className="productInfoContent">
                    {product?.label && <p className="productLabel">{product?.label}</p>}
                    <h3 className="productTitle">{product?.spuName}</h3>
                    {!!product?.description && <p className="productDescription">{product?.description}</p>}
                </div>

                <div className="productItemLinks">
                    {product?.learnLink && (
                        <EcoLink href={handleProductLink(product)} onClick={() => handleLearnMoreClick(product)}>
                            <span className="font-family-medium link" style={{ fontWeight: 400 }}>
                                {t('support.site_support_learn_more')}
                            </span>
                        </EcoLink>
                    )}
                    {product?.buyLink && (
                        <EcoLink href={product?.buyLink} onClick={() => handleBuyNowClick(product)}>
                            <span className="font-family-medium link" style={{ fontWeight: 400 }}>
                                {t('support.site_support_buy_now')}
                            </span>
                        </EcoLink>
                    )}
                </div>
            </div>
        </div>
    );
}
